import React, { Component } from "react"
import { TextField } from "material-ui"
import StateSelector from "../clients/state-selector/StateSelector"
import strings from "../../localization/strings"
import { IAddress } from "../../models"
interface IProps {
    readonly?: boolean
    handleAddress: (address: IAddress) => void
    address: IAddress
    showLatLng: boolean
}

interface IState {
    address: IAddress
    errorLatitude: string
    errorLongitude: string
}

const reg = /^-?\d*(\.\d+)?$/

export class Address extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            address: props.address,
            errorLatitude: "",
            errorLongitude: ""
        }
    }

    changeLatitude(e) {
        const latitude = e.target.value
        this.setState({ address: { ...this.state.address, Latitude: latitude } }, () =>
            !reg.test(latitude) || parseFloat(latitude) > 90 || parseFloat(latitude) < -90
                ? this.setState({ errorLatitude: strings.Input_a_valid_value })
                : this.setState({ errorLatitude: "" })
        )
    }

    changeLongitude(e) {
        const longitude = e.target.value
        this.setState({ address: { ...this.state.address, Longitude: longitude } }, () =>
            !reg.test(longitude) || parseFloat(longitude) > 180 || parseFloat(longitude) < -180
                ? this.setState({ errorLongitude: strings.Input_a_valid_value })
                : this.setState({ errorLongitude: "" })
        )
    }

    handleAddress = () => {
        if (this.state.errorLatitude || this.state.errorLongitude) return
        this.props.handleAddress(this.state.address)
    }

    render() {
        const { address, errorLatitude, errorLongitude } = this.state
        return (
            <div style={{ flex: 3 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                        floatingLabelText={strings.Address}
                        value={address && address.HouseOrBuildingName || ""}
                        style={{ width: "100%" }}
                        onChange={(event) => this.setState({ address: { ...address, HouseOrBuildingName: event.target.value } })}
                        onBlur={() => this.handleAddress()}
                        disabled={this.props.readonly}
                    />
                    <TextField
                        floatingLabelText={strings.Street}
                        value={address && address.StreetName || ""}
                        style={{ width: "100%" }}
                        onChange={(event) => this.setState({ address: { ...address, StreetName: event.target.value } })}
                        onBlur={() => this.handleAddress()}
                        disabled={this.props.readonly}
                    />
                    <TextField
                        floatingLabelText={strings.City}
                        value={address && address.CityTown || ""}
                        style={{ width: "100%" }}
                        onChange={(event) => this.setState({ address: { ...address, CityTown: event.target.value } })}
                        onBlur={() => this.handleAddress()}
                        disabled={this.props.readonly}
                    />
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <StateSelector
                            width={"50%"}
                            state={address && address.GoverningDistrictOrState || ""}
                            handleState={(state) => this.setState({ address: { ...address, GoverningDistrictOrState: state } }, () => this.handleAddress())}
                            readonly={this.props.readonly}
                        />
                        <TextField
                            floatingLabelText={strings.Zip_Postal_code}
                            value={address && address.PostalArea || ""}
                            style={{ width: "50%", marginLeft: "20px" }}
                            onChange={(event) => this.setState({ address: { ...address, PostalArea: event.target.value } })}
                            onBlur={() => this.handleAddress()}
                            disabled={this.props.readonly}
                        />
                    </div>
                    {this.props.showLatLng &&
                        <div>
                            <TextField
                                floatingLabelText={strings.Latitude}
                                value={address && address.Latitude || ""}
                                style={{ width: "100%" }}
                                onChange={(event) => this.changeLatitude(event)}
                                onBlur={() => this.handleAddress()}
                                errorText={errorLatitude}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                                disabled={this.props.readonly}
                            />
                            <TextField
                                floatingLabelText={strings.Longitude}
                                value={address && address.Longitude || ""}
                                style={{ width: "100%" }}
                                onChange={(event) => this.changeLongitude(event)}
                                onBlur={() => this.handleAddress()}
                                errorText={errorLongitude}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                                disabled={this.props.readonly}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default Address
